import React, { useRef, useEffect } from 'react';
import { animate } from 'animejs';
import { getWhatsAppUrl } from '../utils/links';
import { useLanguage } from '../context/LanguageContext';
import logo from '../images/logo_zave.png';
import heroImage from '../images/Hero.png';
import './Hero.css';

const PARALLAX_RATE = 0.35;

function Hero() {
  const { lang, t } = useLanguage();
  const heroRef = useRef(null);
  const bgRef = useRef(null);
  const logoRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const buttonsRef = useRef(null);

  useEffect(() => {
    const bg = bgRef.current;
    if (!bg) return;
    const onScroll = () => {
      const scrollY = window.scrollY;
      const y = scrollY * PARALLAX_RATE;
      bg.style.transform = `translate3d(0, ${y}px, 0)`;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const logoEl = logoRef.current;
    const title = titleRef.current;
    const subtitle = subtitleRef.current;
    const buttons = buttonsRef.current;
    if (!title || !subtitle || !buttons) return;

    if (logoEl) animate(logoEl, { opacity: [0, 1], scale: [0.95, 1], duration: 500, ease: 'outExpo' });
    animate(title, { opacity: [0, 1], y: [28, 0], duration: 600, delay: 200, ease: 'outExpo' });
    animate(subtitle, { opacity: [0, 0.92], y: [24, 0], duration: 550, delay: 350, ease: 'outExpo' });
    const btns = buttons.querySelectorAll('.btn');
    btns.forEach((btn, i) => {
      animate(btn, { opacity: [0, 1], y: [16, 0], duration: 450, delay: 500 + i * 80, ease: 'outExpo' });
    });
  }, []);

  return (
    <section ref={heroRef} className="hero">
      <div
        ref={bgRef}
        className="hero-bg hero-bg--parallax"
        aria-hidden="true"
        role="presentation"
        style={{ backgroundImage: `url(${heroImage})` }}
      />
      <div className="hero-bg-overlay" aria-hidden="true" role="presentation" />
      <div className="hero-inner">
        <img ref={logoRef} src={logo} alt="Transportes ZAVE SpA" className="hero-logo" />
        <h1 ref={titleRef} className="hero-title">
          {t('hero.title')}
        </h1>
        <p ref={subtitleRef} className="hero-subtitle">
          {t('hero.subtitle')}
        </p>
        <div ref={buttonsRef} className="hero-buttons">
          <a
            href={getWhatsAppUrl(lang)}
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('hero.btnWhatsapp')}
          >
            {t('hero.btnWhatsapp')}
          </a>
          <a href="#servicios" className="btn btn-secondary" aria-label={t('hero.btnServices')}>
            {t('hero.btnServices')}
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
